import type React from 'react';

import type { IconProps } from '../types';

export const CrossS: React.FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.4697 4.46966C18.7626 4.17679 19.2374 4.17677 19.5303 4.46966C19.8232 4.76255 19.8232 5.23733 19.5303 5.53022L13.0605 12L19.5303 18.4698C19.8232 18.7627 19.8232 19.2375 19.5303 19.5304C19.2559 19.8048 18.8219 19.8219 18.5274 19.5821L12 13.0606L5.53018 19.5304C5.23729 19.8232 4.7625 19.8232 4.46963 19.5304C4.17676 19.2375 4.17682 18.7627 4.46963 18.4698L10.9394 12L4.41787 5.4726C4.17804 5.17803 4.1952 4.74409 4.46963 4.46966C4.74406 4.19525 5.178 4.17807 5.47257 4.4179L12 10.9395L18.4697 4.46966Z"
      fill={color}
    />
  </svg>
);
